<h2 mat-dialog-title>{{ 'DIALOGS.UNLOADING.title' | translate }}</h2>

<mat-dialog-content [formGroup]="form" style="display: grid">
  @if (sendersCount$ | async) {
    <app-select formControlName="sender">
      <app-select-label>{{ 'QUERY_BUILDER.FIELDS.sender' | translate }}</app-select-label>
      @for (sender of senders$ | async; track sender) {
        <mat-option [value]="sender">{{ sender.name }}</mat-option>
      }
    </app-select>
  } @else {
    <span style="padding: 5px;">{{ 'DIALOGS.UNLOADING.no_senders' | translate }}</span>
    <a [project-route]="['setting', 'senders']"
      [mat-dialog-close]
      color="primary"
      mat-button>
      {{ 'DIALOGS.UNLOADING.create_sender' | translate }}
    </a>
  }

  @if (storehousesCount$ | async) {
    <app-select formControlName="storehouse">
      <app-select-label>{{ 'QUERY_BUILDER.FIELDS.storehouse' | translate }}</app-select-label>
      @for (store of storehouses$ | async; track store) {
        <mat-option [value]="store">{{ store.name }}</mat-option>
      }
    </app-select>
  } @else {
    <span style="padding: 5px;">{{ 'DIALOGS.UNLOADING.no_storehouses' | translate }}</span>
    <a [project-route]="['setting', 'storehouses', 'create']"
      [mat-dialog-close]
      color="primary"
      mat-button>
      {{ 'DIALOGS.UNLOADING.create_storehouse' | translate }}
    </a>
  }
</mat-dialog-content>

<app-button-group>
  <button color="warn" [mat-dialog-close] mat-stroked-button>{{ 'QUERY_BUILDER.close' | translate }}</button>
  <button [disabled]="form.invalid"
    [mat-dialog-close]="checkReserves()"
    color="primary"
    mat-stroked-button>
    {{ 'DIALOGS.UNLOADING.start' | translate }}
  </button>
</app-button-group>
